import React from "react";
import { FormLayout, HeaderActions, Heading, Input, Panel, Text } from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useValidator from "../../base/hooks/form/useValidator";
import useFormActions from "../../base/hooks/form/useFormActions";
import {
    MUTATION_UPDATE_QUICKBOOK_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const AppQuickBookForm = ({ toolbar, app }) => {
    const { user } = useMeta();

    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "access_token",
                method: "isEmpty",
                validWhen: false,
                message: "This access token Id is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    let options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                type: "QuickBook",
            },
        },
    };

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "QuickBook",
        "",
        MUTATION_UPDATE_QUICKBOOK_APP,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
                skip: user.loading || !user.accountId || !user.storeId,
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>QuickBook</Heading>
                        <Text tone="secondary" variant="body-sm">
                            QuickBook Information
                        </Text>
                    </div>
                    <div className={styles.headerActions}>
                        {toolbar ? toolbar : null}
                        <HeaderActions
                            actions={[
                                {
                                    id: "update",
                                    label: "Update",
                                    icon: loading ? undefined : <SaveIcon />,
                                    loading,
                                    disabled: loading,
                                    onClick: () => createOrUpdate(),
                                },
                            ]}
                            aria-label="QuickBook actions"
                        />
                    </div>
                </div>
            }
            showHeaderDivider
        >
            <FormLayout>
                <FormLayout.Section title="Information">
                    <FormLayout.Grid columns={2} maxWidth="twoThirds">
                        <Input
                            error={fieldError(validator, "access_token")}
                            fullWidth
                            label="Access Token"
                            name="access_token"
                            onChange={inputChange}
                            value={inputs.access_token || ""}
                        />
                        <Input
                            fullWidth
                            label="Refresh Token"
                            name="refresh_token"
                            onChange={inputChange}
                            value={inputs.refresh_token || ""}
                        />
                        <Input
                            fullWidth
                            label="Expires In"
                            name="expires_in"
                            onChange={inputChange}
                            value={inputs.expires_in || ""}
                        />
                        <Input
                            fullWidth
                            label="Token Type"
                            name="token_type"
                            onChange={inputChange}
                            value={inputs.token_type || ""}
                        />
                        <Input
                            fullWidth
                            label="Realm Id"
                            name="realmid"
                            onChange={inputChange}
                            value={inputs.realmid || ""}
                        />
                    </FormLayout.Grid>
                </FormLayout.Section>
            </FormLayout>
        </Panel>
    );
};

export default AppQuickBookForm;
